import React from "react";

const ProjectsSection = () => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [isPaused, setIsPaused] = React.useState(false);

  const projects = [
    {
      id: 1,
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
      alt: "Analytics Dashboard",
    },
    {
      id: 2,
      image:
        "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=600&fit=crop",
      alt: "Mobile App",
    },
    {
      id: 3,
      image:
        "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
      alt: "Office Workspace",
    },
  ];

  React.useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % projects.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused, projects.length]);

  const getVisibleProjects = () => {
    const visible = [];
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
    const isTablet =
      typeof window !== "undefined" &&
      window.innerWidth >= 768 &&
      window.innerWidth < 1024;

    if (isMobile) {
      visible.push(currentIndex);
    } else if (isTablet) {
      visible.push(currentIndex, (currentIndex + 1) % projects.length);
    }

    return visible;
  };

  return (
    <section id="projects-section" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-blue-50 text-blue-500 rounded-full text-sm font-medium mb-6">
            OUR WORK
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Featured Projects
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore our portfolio of successful projects that showcase our
            expertise in
            <br />
            delivering exceptional digital solutions.
          </p>
        </div>

        {/* Projects Grid - Desktop */}
        <div className="hidden lg:grid grid-cols-3 gap-8 mb-12">
          {projects.slice(0, 3).map((project) => (
            <div
              key={project.id}
              className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.alt}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Projects Carousel - Mobile & Tablet with Step Animation */}
        <div
          className="lg:hidden mb-12"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="flex gap-8 justify-center items-center min-h-[400px]">
            {projects.map((project, index) => {
              const visibleIndexes = getVisibleProjects();
              const isVisible = visibleIndexes.includes(index);
              const isCenter = index === currentIndex;

              return (
                <div
                  key={project.id}
                  className={`transition-all duration-500 ${
                    isVisible
                      ? "opacity-100 scale-100"
                      : "opacity-0 scale-75 absolute"
                  } ${isCenter ? "md:scale-110 scale-105" : "md:scale-100"} ${
                    isVisible ? "w-full md:w-[calc(50%-16px)]" : "w-0"
                  } bg-white rounded-3xl overflow-hidden shadow-lg`}
                >
                  {isVisible && (
                    <div className="relative h-80 overflow-hidden">
                      <img
                        src={project.image}
                        alt={project.alt}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {projects.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex ? "bg-blue-500 w-8" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>

        {/* View Projects Button */}
        <div className="text-center">
          <button className="bg-blue-500 text-white px-10 py-4 rounded-full text-lg font-medium hover:bg-blue-600 transition-colors duration-300 shadow-lg hover:shadow-xl">
            View Projects
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
